var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOzfNavHome = function SvgOzfNavHome(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18084",
    "data-name": "Rectangle 18084",
    width: 33,
    height: 33,
    fill: "#595959",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-ozf-nav-home"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ozf-nav-home",
    clipPath: "url(#clip-ozf-nav-home)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_12",
    "data-name": "Mask Group 12",
    transform: "translate(1 1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_216242_home_icon",
    "data-name": "216242_home_icon",
    d: "M19.8,4.95S9.593,13.761,3.889,18.533A1.718,1.718,0,0,0,3.3,19.8a1.648,1.648,0,0,0,1.65,1.65h3.3V33A1.648,1.648,0,0,0,9.9,34.65h4.95A1.65,1.65,0,0,0,16.5,33V26.4h6.6V33a1.65,1.65,0,0,0,1.65,1.65H29.7A1.648,1.648,0,0,0,31.35,33V21.45h3.3A1.648,1.648,0,0,0,36.3,19.8a1.617,1.617,0,0,0-.632-1.267C30,13.761,19.8,4.95,19.8,4.95Z",
    transform: "translate(-3.3 -3.3)",
    fill: "#595959"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOzfNavHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ozf-nav-home.e1223e16b487fd50b7fba2e2a4acb0b6.svg";